


































import {Component, Prop, Vue} from 'vue-property-decorator';
import TitleFomatter from './Type/TitleFomatter';
@Component
export default class Header extends Vue {
  @Prop()
  private titleObj!: TitleFomatter;
}
